export enum ElementToggleEnum {
  NORMAL = '',
  ACTIVE = 'active',
  HIDDEN = 'hidden',
}

export enum ElementExpandEnum {
  NORMAL = '',
  EXPANDED = 'expanded',
}

export enum ElementPositionEnum {
  NORMAL = '',
  FIXED = 'fixed',
  FIXED_WITHOUT_SEARCH = 'fixed-without-search',
  FIXED_WITH_SEARCH = 'fixed-with-search',
  HIDDEN = 'hidden',
}

export enum IsHsaEnum {
  NORMAL = '',
  HSA = 'is-hsa',
}

export enum BodyNoScrollEnum {
  NO_SCROLL = 'no-scroll',
}

export enum AdsCssClassEnum {
  NORMAL = '',
  FLUID = 'fluid',
}
